import { ReportsConstants } from '../constants';

export function reports(state = {}, action) {
  switch (action.type) {
    case ReportsConstants.GETCORPORATE_REPORT:
    case ReportsConstants.GETCOUNSELLOR_REPORT:
      return {
        ...state,
        data:''
      };
    case ReportsConstants.CORPORATE_REPORT_SUCCESS:
    case ReportsConstants.COUNSELLOR_REPORT_SUCCESS:
      return {
          ...state,
          data: action.data
          
      };
    case ReportsConstants.CORPORATE_REPORT_FAILURE:
    case ReportsConstants.COUNSELLOR_REPORT_FAILURE:
      return {
          ...state,
          data:''
      };
    case ReportsConstants.RESET_REPORTS:
        return{
          ...state,
          data:''
        }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/reports.reducer.js